import { useSelector } from "react-redux";
import {
    AVAILABILITY_CHOICE,
    EVENT_TYPE,
    SELECTORS,
    useEventDataOfSelectedEvent,
} from "@Utils";
import { INoSlotsAvailableProps } from "./NoSlotsAvailable";

const useNoSlotsAvailable = ({
    showGuestInfoModal,
}: INoSlotsAvailableProps) => {
    const hostData = useSelector(SELECTORS.hostData);
    const {
        eventData: { type: eventType, availability_choice: availabilityChoice },
    } = useEventDataOfSelectedEvent();

    const ctaText: string = hostData?.interest_cta_text || "get in touch";
    let showCta = true;

    let [pre, post] = [
        // default case: when `disablePayment === true`
        "There are no slots available currently.",
        "to request a new slot.",
    ];

    if (eventType === EVENT_TYPE.MERCHANDISE) {
        [pre, post] = [
            "This item is currently sold out.",
            "to discuss the availability",
        ];
    }
    if (
        eventType === EVENT_TYPE.APPOINTMENTS &&
        availabilityChoice === AVAILABILITY_CHOICE.NOT_DECIDED
    ) {
        showCta = false;
        [pre, post] = [
            "The session schedule will be shared with you after booking.",
            "",
        ];
    }

    const onCtaCLick = showGuestInfoModal;

    return { showCta, ctaText, onCtaCLick, pre, post };
};

export default useNoSlotsAvailable;
